module.exports = __webpack_public_path__ + "static/media/app-mockup.de6658a5.png";